import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/map";
import { Event } from '../../interface/event';
import { Site } from "../../interface/site";


@Injectable()
export class EventService {
  eventAction = new Subject();

  constructor(private router: Router, private httpClient: HttpClient) {}

  create(eventForm): Observable<any> {
    let body = eventForm;
    return this.httpClient.post("event", body);
  }

  list(filter = ""): Observable<Event[]> {
    if (filter) {
      filter = "?" + filter;
    }
    return this.httpClient.get<Event[]>("event" + filter);
  }

  delete(eventId): Observable<any> {
    return this.httpClient.delete("event/" + eventId);
  }

  siteMasterList(name = ""): Observable<Site[]> {
    let filter = "";
    if (name) {
      filter = "?fields=siteName,isActive,address&limit=5&where[siteName]=" + name;
    }
    return this.httpClient.get<Site[]>('site' + filter);
  }

  update(eventForm): Observable<any> {
    let body = eventForm;
    return this.httpClient.patch("event", body);
  }

  getAction ():Observable<any>{
    return this.eventAction.asObservable();
  }

  sendAction (action, data){
    this.eventAction.next({action: action, data: data})
  }

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/event/event.service.ts